import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ImportControlService } from 'src/app/popup/services/import-control.service';
import { MenuManagementService } from '../services/menu-management.service';
import {
  ObstacleDataCsvComponent
} from 'src/app/popup/import/obstacle-data-csv/obstacle-data-csv/obstacle-data-csv.component';
import {TrajectoriesRvtKmzComponent} from 'src/app/popup/import/trajectories-rvt-kmz/trajectories-rvt-kmz.component';
import {AirspaceVertexComponent} from 'src/app/popup/import/airspace-vertex/airspace-vertex.component';
import {SAAMtraficImportComponent} from 'src/app/popup/saamtrafic-import/saamtrafic-import.component';
import {ImportUserLayerComponent} from 'src/app/popup/import-user-layer/import-user-layer.component';
import {ProjectService} from 'src/app/services/project.service';
import {ModalConfirmationService} from 'src/app/services/modal-confirmation.service';
import {PointsService} from 'src/app/services/points.service';
import {GritUserRoleGroup, GritUserService} from "../../services/grit/grit.user.service";
import {GritInterferenceTestService} from "../../services/grit/grit.interference-test.service";
import {InterferenceTestModelStates} from "../../models/grit/grit.enums";
import { ImportFormat } from 'src/app/models/importFormat';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { EndpointsService } from 'src/app/services/endpoints.service';

@Component({
  selector: 'app-import-menu',
  templateUrl: './import-menu.component.html',
  styleUrls: ['./import-menu.component.scss'],
  standalone: false
})
export class ImportMenuComponent implements OnInit {

  readonly navaidsFormats: ImportFormat[] = ImportFormat.NAVAIDS_FORMATS;
  readonly coordPointsFormats: ImportFormat[] = ImportFormat.COORD_POINTS_FORMATS;
  readonly proceduresFormats: ImportFormat[] = ImportFormat.PROCEDURES_FORMATS;
  readonly aerodromesFormats: ImportFormat[] = ImportFormat.AERODROMES_FORMATS;
  readonly flightInspectionFormats: ImportFormat[] = ImportFormat.FLIGHT_INSPECTION_FORMATS;
  readonly routeSegmentsFormats: ImportFormat[] = ImportFormat.ROUTE_SEGMENTS_FORMATS;
  readonly vertexFormats: ImportFormat[] = ImportFormat.VERTEX_FORMATS;
  readonly rvtKmzFormats: ImportFormat[] = ImportFormat.RVT_KMZ_FORMATS;
  readonly airSpaceBoundariesFormats: ImportFormat = ImportFormat.AIR_SPACE_BOUNDARIES_FORMATS;
  readonly layerFormats: ImportFormat = ImportFormat.LAYER_FORMATS;
  readonly saamLayerFormats: ImportFormat = ImportFormat.SAAM_LAYER_FORMATS;

  //#region GRIT
  gritFormats : string[] = ['JSON'];
  //endregion

  constructor(public menuService: MenuManagementService,
     public importService: ImportControlService,
     private pointsController: PointsService,
     private popupService: BsModalService,
     private projectService : ProjectService,
     private endpointsService: EndpointsService,
     public confirmationModal : ModalConfirmationService,
     public readonly configurationService: ConfigurationService,
     public  gritUserService: GritUserService,
     public  gritInterferenceTestService: GritInterferenceTestService,
     ) {

  }

  ngOnInit(): void {
  }

  openObstacleDataImport() {
    const bsModalRef: BsModalRef = this.popupService.show(ObstacleDataCsvComponent);
  }

  uploadAirSpaceBoundaryXML($file: any) {
    if (this.projectService.projectEditable()) {
      this.confirmationModal.showMesssageConfirmationModal("Warning!", "This action will override the existing data.Do you want to continue?", "OK", "Cancel", () => this.pointsController.uploadAirSpaceBoundary($file));
    }
  }

  openTrajectoriesRvtKmzImport() {
    const bsModalRef: BsModalRef = this.popupService.show(TrajectoriesRvtKmzComponent);
  }

  openAirspaceVertexImport() {
    const bsModalRef: BsModalRef = this.popupService.show(AirspaceVertexComponent);
  }
  openSAAMTraficdensityImport(file: File) {
    const bsModalRef: BsModalRef = this.popupService.show(SAAMtraficImportComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    })
    bsModalRef.content.file = file;
  }
  openImportLayer(file: File) {
    const bsModalRef: BsModalRef = this.popupService.show(ImportUserLayerComponent);
    bsModalRef.content.file = file;
  }

  protected readonly GritUserRoleGroup = GritUserRoleGroup;
  protected readonly InterferenceTestModelStates = InterferenceTestModelStates;

  // Unified validator with optional Calculation Manager check.
  // - Always ensures roles token is present (for admin check on Default project)
  // - Always validates project editability (Default project requires admin)
  // - Optionally validates Calculation Manager status when checkCalculationManager is true
  async validateProjectPermissions(checkCalculationManager: boolean = false): Promise<boolean> {
    try {
      await this.endpointsService.setUserRolesToken();
    } catch {
      // ignore; rely on whatever token is available
    }

    if (!this.projectService.projectEditable(null, true)) {
      return false;
    }

    if (!checkCalculationManager) {
      return true;
    }
    return this.configurationService.operationAllowedByCalculationManager(true);
  }
}
